module.exports = __webpack_public_path__ + "static/media/IMG-27.6e2d83f1.jpg";